module.exports = __webpack_public_path__ + "img/logo-base-CMS.75814b5b.svg";